/*
 * @Author: your name
 * @Date: 2021-03-30 10:30:04
 * @LastEditTime: 2021-08-18 14:36:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\settled.js
 */
export default [
    {
        path: '/sales',
        component: resolve => require(['../../views/sales/sales.vue'], resolve),
        meta: { title: '客户管理' }
    },
    {
        path: '/suppliers',
        component: resolve => require(['../../views/suppliers/suppliers.vue'], resolve),
        meta: { title: '我的供应商' }
    },
    {
        path: '/orgSuppliers',
        component: resolve => require(['../../views/suppliers/orgSuppliers.vue'], resolve),
        meta: { title: '供应商设置' }  //总部
    },
    {
        path: '/orgSuppliersList',
        component: resolve => require(['../../views/suppliers/orgSuppliersList.vue'], resolve),
        meta: { title: '供应商列表' }  //总部
    },
    {
        path: '/headMySuppliers',
        component: resolve => require(['../../views/suppliers/headMySuppliers.vue'], resolve),
        meta: { title: '我的供应商' }  //总部特许经营 门店
    },
    {
        path: '/headSelfsupportSuppliers',
        component: resolve => require(['../../views/suppliers/headSelfsupportSuppliers.vue'], resolve),
        meta: { title: '自营供应商' }  //总部特许经营 门店
    },    
    {
        path: '/proprietarys',
        component: resolve => require(['../../views/suppliers/proprietarys.vue'], resolve),
        meta: { title: '自营供应商设置' }
    },
    {
        path: '/proprietary',
        component: resolve => require(['../../views/supplier/proprietary.vue'], resolve),
        meta: { title: '自营供应商设置' }
    },
    
    {
        path: '/supplier',
        component: resolve => require(['../../views/supplier/supplier.vue'], resolve),
        meta: { title: '过滤供应商设置' }
    },   

    {
        path: '/settled-list',
        component: resolve => require(['../../views/settled/index.vue'], resolve),
        meta: { title: '入驻列表' }
    },
    {
        path: '/add-settle',
        component: resolve => require(['../../views/settled/AddSettled.vue'], resolve),
        meta: { title: '新增入驻' }
    },
    {
        path: '/insurance-list-shop',
        component: resolve => require(['../../views/insuranceList/shopList.vue'], resolve),
        meta: { title: '保险列表' }
    },
    {
        path: '/org-insurance-list-shop',
        component: resolve => require(['../../views/insuranceList/org-insurance-list-shop.vue'], resolve),
        meta: { title: '下属门店保险列表' }
    },
    {
        path: '/insurance-list',
        component: resolve => require(['../../views/insuranceList/perList.vue'], resolve),
        meta: { title: '保险列表' }
    },
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/settled.js